import React from 'react';
import { oneOf, string, bool } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';

const Message = ({ channel, discount, disabled }) => {

  const tooltip = (
    <div className="subscribe-and-save-tooltip" id="subscribe-and-save-tooltip">
      <div className="subscribe-and-save-tooltip__container">
        <div className="subscribe-and-save-tooltip__container-info">
          <div className="subscribe-and-save-tooltip__container-info__icon">
            <div className="subscribe-and-save-icons delivery" />
          </div>
          <div className="message">{discount}% off subscription purchases plus free delivery</div>
        </div>
        <div className="subscribe-and-save-tooltip__container-info">
          <div className="subscribe-and-save-tooltip__container-info__icon">
            <div className="subscribe-and-save-icons deliverymanagement" />
          </div>
          <div className="message">Pause or cancel your subscription anytime online</div>
        </div>
        <div className="subscribe-and-save-tooltip__container-info">
          <div className="subscribe-and-save-tooltip__container-info__icon">
            <div className="subscribe-and-save-icons nomembershipfee" />
          </div>
          <div className="subscribe-and-save-tooltip__container-info__message">No club or membership fees required</div>
        </div>
      </div>
      <br />
      <p>
        Subscribe to this product today to receive free delivery directly
        to your doorstop at your convenience. Just select your preferred
        delivery frequency from the drop down menu and checkout to start
        your subscription.
      </p>
    </div>
  );

  return disabled
    ? (
      <div className="subscribe-and-save-message--disabled">
        <span>Available for Ship to Home only.</span>
      </div>
    )
    : (
      <div className="subscribe-and-save-message">
        <span>Schedule your product to be delivered for free when you need it most. </span>
        <Tooltip channel={channel} placement="bottom" content={tooltip} closeButton>
          <button
            type="button"
            className="u__default-link subscribe-and-save-message__learn-more scrollTouch"
            id="subscribe-and-save-message__learn-more"
          >
            Learn More
          </button>
        </Tooltip>
      </div>
    );
};

Message.displayName = 'SubscribeAndSave-Message';

Message.propTypes = {
  channel: oneOf(['mobile', 'desktop']),
  discount: string,
  disabled: bool
};

Message.defaultProps = {
  channel: 'desktop',
  discount: '5',
  disabled: false
};

export { Message };